import { render, staticRenderFns } from "./VChat.vue?vue&type=template&id=00c5cadc&"
import script from "./VChat.vue?vue&type=script&lang=ts&"
export * from "./VChat.vue?vue&type=script&lang=ts&"
import style0 from "./VChat.vue?vue&type=style&index=0&id=00c5cadc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports